import React, { useMemo } from 'react';
import { ServiceDetails } from 'types/index';
import Icon, { MaterialIcons } from "app/common/Icon/index";
import classes from './style.module.scss';
import useTranslation from "app/hooks/useTranslation";
import { ServiceStatuses } from '~/app/data/statuses/services';

export interface StatusMessageProps {
    item: ServiceDetails
}

export type StatusMessageComponent = React.FC<StatusMessageProps>

const StatusMessage: StatusMessageComponent = ({ item }) => {

    const { t } = useTranslation("service.statusMessages");

    const icon = useMemo<MaterialIcons | undefined>(() => {
        if (item.status === ServiceStatuses['TRIGGERED'] || item.status === ServiceStatuses['INPROGRESS']) {
            return 'check';
        } else if (item.status === ServiceStatuses['CANCELLED']) {
            return 'error_outline';
        } else if (item.status === ServiceStatuses['COMPLETED'] || item.status === ServiceStatuses['PARTIALLLYCOMPLETED']) {
            return 'done_all';
        }
    }, [item]);

    if (item.status === ServiceStatuses['PREVIOUS']) {
        return null;
    }

    return (
        <>
            <div className={`${classes['service-message']} ${classes[item.status]} `}>
                <Icon name={icon} className={classes['icon']}/>
                <span>
                    {t(item.status.toString(),
                        {
                            date: item.statusDate,
                            department: item.departmentName
                        }
                    )}
                </span>
            </div>
        </>
    );
}

export default StatusMessage
